export default __webpack_public_path__ + "static/media/word.2220eb77.svg";